import Vue from 'vue';
import Router from 'vue-router';
import store from '@/vuex/store';
import config from '@/config';

import Site from '@/Site';
import Impresso from '@/Impresso';
import Login from '@/pages/login';
import NaoEncontrado from '@/pages/nao-encontrado';
import CredenciamentoSesc from '@/pages/credenciamento-sesc';
import SemAcesso from '@/pages/sem-acesso';
import UorNaoParticipante from '@/pages/uor-nao-participante';
import Manutencao from '@/pages/manutencao';
import Construcao from '@/pages/construcao';
import Encerrado from '@/pages/recadastramento/encerrado';
import EncerradoFamiliar from '@/pages/dependente-cpf/encerrado';
import Conta from '@/pages/conta';
import Sair from '@/pages/sair';
import Faq from '@/pages/faq';
import Home from '@/pages/home';
import Dependente from '@/pages/dependente';
import DependenteCpf from '@/pages/dependente-cpf';
import DeclaracaoBens from '@/pages/declaracao';
import Avaliacao from '@/pages/avaliacao';
import DetalhaAvaliacao from '@/pages/avaliacao/detalha-avaliacao';
import Avaliados from '@/pages/avaliacao/avaliados';
import AvaliacaoEstagioProbatorio from '@/pages/avaliacao-estagio-probatorio';
import DetalhaAvaliacaoEstagioProbatorio from '@/pages/avaliacao-estagio-probatorio/detalha-avaliacao';
import AvaliadosEstagioProbatorio from '@/pages/avaliacao-estagio-probatorio/avaliados';
import DadosPessoais from '@/pages/recadastramento/dados-pessoais';
import Endereco from '@/pages/recadastramento/endereco';
import Contatos from '@/pages/recadastramento/contatos';
import Documentacao from '@/pages/recadastramento/documentacao';
import Filiacao from '@/pages/recadastramento/filiacao';
import Envio from '@/pages/recadastramento/envio';
import Fim from '@/pages/recadastramento/fim';
import Ferias from '@/pages/ferias/agendamento';
import Aprovacao from '@/pages/ferias/aprovacao';
import FaltaLei from '@/pages/falta-lei';
import PaginaFaltaLeiImpresso from '@/pages/falta-lei/pagina-impresso';
import { confereClicados, contaCliques } from './favoritos';
import { avisaAntesDeTokenExpirar, forcaLogout } from './tokenExpirado';
import validaRecadastramento from './validaRecadastramento';
import { validaRecadastramentoPorId } from './validaRecadastramento';
import validaPeriodoRecadastramentoFamiliar from './validaPeriodoRecadastramentoFamiliar';
import PeriodoEncerrado from '@/pages/periodo-encerrado';
import MesCompetenciaOrdenado from '@/pages/recadastramento/mes-competencia-ordenado/index.vue';
import ValeAlimentacao from '@/pages/vale-alimentacao/index.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: config.publicPath,
  routes: [
    {
      path: '/',
      component: Site,
      children: [
        {
          path: '',
          name: 'Login',
          component: Login,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'sem-acesso',
          name: 'SemAcesso',
          component: SemAcesso,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'periodo-encerrado',
          name: 'PeriodoEncerrado',
          component: PeriodoEncerrado,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'uor-nao-participante',
          name: 'UorNaoParticipante',
          component: UorNaoParticipante,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'manutencao',
          name: 'Manutencao',
          component: Manutencao,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'construcao',
          name: 'Construcao',
          component: Construcao,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'sair',
          name: 'Sair',
          component: Sair.default,
        },
        {
          path: 'conta',
          name: 'Conta',
          component: Conta,
        },
        {
          path: 'faq',
          name: 'Faq',
          component: Faq,
          meta: {
            declaraActive: true,
          },
        },
        {
          path: 'home',
          name: 'Home',
          component: Home,
        },
        {
          path: 'avaliacao',
          name: 'Avaliacao',
          component: Avaliacao,
          meta: {
            avaliaActive: true,
            contavel: true,
            titulo: 'Avaliação Periódica',
            imagem: 'ico-contagem.png',
            texto:
              'Faça sua avaliação periódica e veja as conclusões do seu avaliador.',
          },
        },
        {
          path: 'avaliacaoEstagioProbatorio',
          name: 'AvaliacaoEstagioProbatorio',
          component: AvaliacaoEstagioProbatorio,
          meta: {
            avaliaActive: true,
            contavel: true,
            titulo: 'Estágio Probatório',
            imagem: 'ico-contagem.png',
            texto:
              'Faça sua avaliação de estágio probatório e veja as conclusões do seu avaliador.',
          },
        },
        {
          path: 'declaracao',
          name: 'DeclaracaoBens',
          component: DeclaracaoBens,
          meta: {
            declaraActive: true,
            contavel: true,
            titulo: 'Declaração de Bens',
            imagem: 'ico-holerites.png',
            texto:
              'Declare seus bens conforme previsto no Decreto Municipal nº 7.517/2016 .',
          },
        },
        {
          path: 'dependente_economico',
          name: 'Dependente',
          component: Dependente,
          meta: {
            declaraActive: true,
            contavel: true,
            titulo: 'Parceiro Econômico',
            imagem: 'ico-holerites.png',
            texto:
              'Inclua parceiros (dependente econômico) que partilhem bens de sua declaração.',
          },
        },
        {
          path: 'avaliacao/avaliados/:idAvaliador',
          name: 'Avaliados',
          component: Avaliados,
          meta: {
            avaliaActive: true,
          },
        },
        {
          path: 'avaliacao_estagio_probatorio/avaliados/:idAvaliador',
          name: 'AvaliadosEstagioProbatorio',
          component: AvaliadosEstagioProbatorio,
          meta: {
            avaliaActive: true,
          },
        },
        {
          path: 'avaliacao/detalha_avaliacao/:idAvaliador/:idAvaliado',
          name: 'DetalhaAvaliacao',
          component: DetalhaAvaliacao,
          meta: {
            avaliaActive: true,
          },
        },
        {
          path: 'avaliacao_estagio_probatorio/detalha_avaliacao/:idAvaliador/:idAvaliado',
          name: 'DetalhaAvaliacaoEstagioProbatorio',
          component: DetalhaAvaliacaoEstagioProbatorio,
          meta: {
            avaliaActive: true,
          },
        },
        {
          path: 'recadastramento/mes-competencia-ordenado',
          name: 'MesCompetenciaOrdenado',
          component: MesCompetenciaOrdenado,
          meta: {
            title: 'Dados Pessoais',
            requiresAuth: true,
          },
        },
        {
          path: 'recadastramento/dados_pessoais/index.vue/:id',
          name: 'DadosPessoais',
          component: DadosPessoais,
          meta: {
            requiresAuth: true,
            stepNumber: 1,
          },
          beforeEnter: async (to, from, next) => {
            if (store.state.token) {
              const periodoId = to.params.id || sessionStorage.getItem('userId'); // query parameters
              if(periodoId) {
                  //const isRecadastra = await validaRecadastramento(next, to);
                   const isRecadastra = await validaRecadastramentoPorId(periodoId, to);
                  if (isRecadastra) {
                    next();
                  } else {
                    next({ name: 'Encerrado' });
                  }
             }
            }
          },
        },
        /*
        {
          path: 'recadastramento/dados_pessoais',
          name: 'DadosPessoais',
          component: DadosPessoais,
          meta: {
            recadastraActive: true,
            contavel: false,
            titulo: 'Recadastro',
            imagem: 'ico-previdenciario.png',
            texto:
              'Mantenha seus dados atualizados podendo enviar seus documentos pela internet.',
            stepNumber: 1,
            displayName: 'Dados Pessoais',
          },
          beforeEnter: async (to, from, next) => {
            if (store.state.token) {
              const isRecadastra = await validaRecadastramento(next, router.app);
              if (isRecadastra) {
                next();
              } else {
                next({ name: 'Encerrado' });
              }
            }
          },
        },
        */
        {
          path: 'recadastramento/dependente_cpf',
          name: 'DependenteCpf',
          component: DependenteCpf,
          meta: {
            recadastraActive: true,
            contavel: true,
            titulo: 'CPF do Familiar',
            imagem: 'ico-previdenciario.png',
            texto:
              'Inclusão do CPF dos familiares.',
          },
          beforeEnter: async (to, from, next) => {
            if (store.state.token) {
              const isRecadastra = validaPeriodoRecadastramentoFamiliar('08/08/2022');
              if (isRecadastra) {
                next();
              } else {
                next({ name: 'EncerradoFamiliar' });
              }
            }
          },
        },
        {
          path: 'recadastramento/dependente_cpf/encerrado',
          name: 'EncerradoFamiliar',
          component: EncerradoFamiliar,
          meta: {
            recadastraActive: true,
            displayName: 'EncerradoFamiliar',
          },
        },
        {
          path: 'recadastramento/endereco',
          name: 'Endereco',
          component: Endereco,
          meta: {
            recadastraActive: true,
            stepNumber: 2,
            displayName: 'Endereço',
          },
        },
        {
          path: 'recadastramento/contatos',
          name: 'Contatos',
          component: Contatos,
          meta: {
            recadastraActive: true,
            stepNumber: 3,
            displayName: 'Contatos',
          },
        },
        {
          path: 'recadastramento/documentacao',
          name: 'Documentacao',
          component: Documentacao,
          meta: {
            recadastraActive: true,
            stepNumber: 4,
            displayName: 'Documentação',
          },
        },
        {
          path: 'recadastramento/filiacao',
          name: 'Filiacao',
          component: Filiacao,
          meta: {
            recadastraActive: true,
            stepNumber: 5,
            displayName: 'Família',
          },
        },
        {
          path: 'recadastramento/envio',
          name: 'Envio',
          component: Envio,
          meta: {
            recadastraActive: true,
            stepNumber: 6,
            displayName: 'Envio',
          },
        },
        {
          path: 'recadastramento/fim',
          name: 'Fim',
          component: Fim,
          meta: {
            recadastraActive: true,
            stepNumber: 7,
            displayName: 'Fim',
          },
        },
        {
          path: 'recadastramento/encerrado',
          name: 'Encerrado',
          component: Encerrado,
          meta: {
            recadastraActive: true,
            displayName: 'Encerrado',
          },
        },
        {
          path: 'ferias/agendamento',
          name: 'Ferias',
          component: Ferias,
          meta: {
            feriasActive: true,
            contavel: true,
            titulo: 'Agendar Férias',
            imagem: 'ico-ferias.png',
            texto:
              'Agende suas férias planejando o melhor período de acordo com feriados futuros.',
          },
        },
        {
          path: 'ferias/aprovacao',
          name: 'Aprovacao',
          component: Aprovacao,
          meta: {
            feriasActive: true,
            contavel: true,
            titulo: 'Aprovar Férias',
            imagem: 'ico-ferias.png',
            texto:
              'Analise e coordene as férias dos membros da sua equipe a partir de uma macro visão.',
          },
        },
        {
          path: 'vale-alimentacao',
          name: 'ValeAlimentacao',
          component: ValeAlimentacao,
          meta: {
            valeAlimentacaoActive: true,
            contavel: true,
            titulo: 'Solicitação de Vale Alimentação',
            imagem: 'ico-holerites.png',
            texto: 'Escolha a empresa de sua preferência para o Vale-Alimentação.',
          },
        },
        {
          path: 'falta_lei',
          name: 'FaltaLei',
          component: FaltaLei,
          meta: {
            formulariosActive: true,
            contavel: true,
            titulo: 'Formulário Falta Lei',
            imagem: 'ico-previdenciario.png',
            texto:
              'Imprima seu formulário de solicitação de falta lei com seus dados já inclusos.',
          },
        },
        {
          path: 'declaracao-inclusao-imposto-renda',
          name: 'DeclaracaoInclusaoImpostoRenda',
          component: () => import('@/pages/declaracao-inclusao-imposto-renda/index.vue'),
          meta: {
            formulariosActive: true,
            contavel: true,
            titulo: 'Declaração de Inclusão IR',
            imagem: 'ico-previdenciario.png',
            texto:
              'Imprima sua declaração de inclusão de dependentes para Imposto de Renda.',
          },
        },
        {
          path: 'declaracao-exclusao-imposto-renda',
          name: 'DeclaracaoExclusaoImpostoRenda',
          component: () => import('@/pages/declaracao-exclusao-imposto-renda/index.vue'),
          meta: {
            formulariosActive: true,
            contavel: true,
            titulo: 'Declaração de Exclusão IR',
            imagem: 'ico-previdenciario.png',
            texto:
              'Imprima sua declaração de exclusão de dependentes para Imposto de Renda.',
          },
        },
        {
          path: 'nao-encontrado',
          name: 'NaoEncontrado',
          component: NaoEncontrado,
        },
        {
          path: '*',
          redirect: 'nao-encontrado',
        },
        {
          path: '/credenciamento-sesc',
          name: 'CredenciamentoSesc',
          component: CredenciamentoSesc,
          meta: {
            titulo: 'Credenciamento Sesc',
          },
        },
      ],
    },
    {
      path: '/impresso',
      component: Impresso,
      children: [
        {
          path:
            'falta_lei/:diaSolicitacao/:mesSolicitacao/:anoSolicitacao/' +
            ':diaFalta/:mesFalta/:anoFalta/:index',
          name: 'FaltaLeiImpresso',
          component: PaginaFaltaLeiImpresso,
        },
        {
          path: 'declaracao-inclusao-imposto-renda',
          name: 'DeclaracaoInclusaoImpostoRendaImpresso',
          component: () => import('@/pages/declaracao-inclusao-imposto-renda/pagina-impresso.vue'),
        },
        {
          path: 'declaracao-exclusao-imposto-renda',
          name: 'DeclaracaoExclusaoImpostoRendaImpresso',
          component: () => import('@/pages/declaracao-exclusao-imposto-renda/pagina-impresso.vue'),
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const tokenEhValido = store.state.token;
  const sshdLogado = store.state.usuarioLogado.sshd;

  if (from.name === 'Login' && tokenEhValido) {
    const rotas = router.options.routes[0].children;
    confereClicados(sshdLogado, rotas);
    avisaAntesDeTokenExpirar(router.app);
    forcaLogout(router);
  }

  if (to.path === '/' && tokenEhValido) {
    next({ name: 'Home' });
    return;
  }

  contaCliques(to, sshdLogado);

  if (to.meta.requiresAuth === false) {
    next();
    return;
  }

  if (!tokenEhValido) {
    next({ path: '/' });
    return;
  }

  if (to.name === 'Sair') {
    Sair.logout(router.app, next);
    return;
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js